<template>
    {{ translation }}
</template>

<script>
import { TStrings } from '../global.js';
export default {
    name: 'T',
    computed: {
        translations() {
            return TStrings.value
        },
        translation() {
            if (this.$slots.default()) {
                if(this.translations.hasOwnProperty(this.$slots.default()[0].children)) {
                    return this.translations[this.$slots.default()[0].children];
                }
                return this.$slots.default()[0].children
            }
            return "";
        },
    }
}
</script>